import { createSpeechPlayer } from "./speech-player.js";
import { ALLOWED_OPTIONS } from "./constants.js";
import { getTranslations } from "./translations/translations.js";

let synth;

document.addEventListener("DOMContentLoaded", () => {
    const scriptTag = document.currentScript || document.querySelector("script[container-selector]");

    if (!scriptTag) {
        return;
    }

    const rootSelector = scriptTag.getAttribute("root-selector");
    const containerSelector = scriptTag.getAttribute("container-selector");
    const language = scriptTag.getAttribute("language") || "en";

    const translations = getTranslations(language);

    if (!containerSelector) {
        console.error(translations.no_container_selector_found);
        return;
    }

    const root = rootSelector ? document.querySelector(rootSelector) : document.body;
    const containerElement = document.querySelector(containerSelector);

    synth = createSpeechPlayer(root, containerElement, ALLOWED_OPTIONS, translations);
});

window.addEventListener("beforeunload", () => {
    synth?.cancel();
});

window.addEventListener("pagehide", () => {
    synth?.cancel();
});
